import KunLoading89 from './src/index'

KunLoading89.install = function (Vue) {
	Vue.component(KunLoading89.name, KunLoading89);
}

export default KunLoading89;
